import { render, staticRenderFns } from "./ProductAttributesOverdraft.vue?vue&type=template&id=4e4a0ccf&scoped=true&lang=pug&"
import script from "./ProductAttributesOverdraft.vue?vue&type=script&lang=js&"
export * from "./ProductAttributesOverdraft.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributesOverdraft.vue?vue&type=style&index=0&id=4e4a0ccf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a0ccf",
  null
  
)

/* custom blocks */
import block0 from "./ProductAttributesOverdraft.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports